import { onMounted, ref } from "vue";

export const setupWindowSize = () => {
  const windowSize = ref({ x: 0, y: 0 });
  const onResize = () => {
    windowSize.value = { x: window.innerWidth, y: window.innerHeight };
  };

  onMounted(onResize);
  return { windowSize, onResize };
};
